function calculateAge(dateOfBirth) {
  const birthYear = dateOfBirth ? new Date(dateOfBirth).getFullYear() : null;
  const currentYear = new Date().getFullYear();
  return birthYear ? `${currentYear - birthYear}Y` : "";
}
export default calculateAge;
